import { Link, Navigate, useParams } from "react-router-dom";
import { CORPORATE_NEWS } from "../CorporatePortalContent";

export default function CorporateNewsDetailPage() {
  const { newsId } = useParams();
  const item = CORPORATE_NEWS.find((row) => row.id === newsId);

  if (!item) {
    return <Navigate to="/news" replace />;
  }

  return (
    <>
      <section className="corporate-page-banner">
        <div className="corporate-page-banner-inner">
          <div className="corporate-news-meta">
            <span>{item.date}</span>
            <span>{item.category}</span>
          </div>
          <h1 className="corporate-page-banner-title">{item.title}</h1>
          <p className="corporate-page-banner-desc">{item.summary}</p>
        </div>
      </section>

      <div className="corporate-page">
        <section className="corporate-section" style={{ paddingTop: 40 }}>
          <div className="corporate-card">
            <p className="corporate-card-text" style={{ fontSize: 16, lineHeight: 1.9 }}>
              {item.content}
            </p>
          </div>
          <div style={{ marginTop: 24 }}>
            <Link to="/news" className="corporate-btn corporate-btn-primary">
              返回新闻列表
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}
